import { render, staticRenderFns } from "./NewsContainer.vue?vue&type=template&id=6dc487d1&scoped=true&"
import script from "./NewsContainer.vue?vue&type=script&lang=js&"
export * from "./NewsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsContainer.vue?vue&type=style&index=0&id=6dc487d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc487d1",
  null
  
)

export default component.exports